define.alias("shared/components/shared/ui/switcher/list", "calendar/components/shared/ui/switcher/list");